import { ArrowRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { LOCATION_HUB_LIST, MAIN_NAV_ITEMS } from "@/utils/newsroomCollections";

const STATIC_BRAND_LOGO = "https://customer-assets.emergentagent.com/job_content-watch-7/artifacts/thy81wjj_747B42A6-4C25-4A17-A557-B9BBE91C99DB%20Background%20Removed.png";
const FNN_SUPPORT_LOGO = "https://customer-assets.emergentagent.com/job_content-watch-7/artifacts/mis2l97l_FNNCW%20LOGO%20UPDATED.png";

export const SiteFooter = ({ siteData }) => (
  <footer className="border-t border-[#D9DCE1] bg-[#F8F9FA]" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 sm:py-16 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)_minmax(0,1fr)] lg:gap-12 lg:px-8">
      <div className="space-y-6">
        <div className="flex items-center gap-4 sm:gap-5">
          <div className="flex h-16 w-16 shrink-0 items-center justify-center overflow-hidden border border-[rgba(10,15,26,0.12)] bg-white p-2 shadow-[0_10px_30px_rgba(10,15,26,0.05)]" data-testid="footer-brand-logo">
            <img alt="Content Watch logo" className="h-full w-full object-contain" src={STATIC_BRAND_LOGO} />
          </div>
          <div>
            <p className="font-[Montserrat] text-2xl font-black uppercase tracking-[0.08em] text-slate-950" data-testid="footer-brand-name">CONTENT WATCH HQ</p>
            <p className="mt-2 text-sm text-slate-600" data-testid="footer-phone">346-675-2374</p>
            <p className="mt-1 text-sm text-slate-600" data-testid="footer-email">info@contentwatchhq.com</p>
          </div>
        </div>
        <p className="max-w-md text-sm leading-7 text-slate-700" data-testid="footer-brand-description">Federal News Network Inc. supports Content Watch HQ operations as the newsroom expands independent coverage across Houston and Southeast Texas.</p>
        <div className="flex h-auto w-full max-w-[320px] items-center overflow-hidden border border-[#D9DCE1] bg-white p-3 shadow-[0_10px_30px_rgba(10,15,26,0.04)]" data-testid="footer-fnn-branding-logo">
          <img alt="Federal News Network branding logo" className="h-auto w-full object-contain" src={FNN_SUPPORT_LOGO} />
        </div>
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="flex flex-wrap gap-3 sm:gap-4">
            <Button asChild className="rounded-none bg-[#D21404] px-6 py-6 text-xs font-bold uppercase tracking-[0.2em] text-white hover:bg-[#B31203]" data-testid="footer-breaking-news-button">
              <Link to="/breaking-news">
                Breaking News
                <ArrowRight size={18} weight="bold" />
              </Link>
            </Button>
            <Button asChild className="rounded-none border border-[#0A0A0A] bg-transparent px-6 py-6 text-xs font-bold uppercase tracking-[0.2em] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white" data-testid="footer-newsroom-login-button" variant="ghost">
              <Link to="/newsroom-login">Newsroom Login</Link>
            </Button>
          </div>
          {siteData?.family_logo && siteData.family_logo !== STATIC_BRAND_LOGO ? (
            <div className="flex h-16 w-[220px] items-center justify-end overflow-hidden border border-[#D9DCE1] bg-white p-3 shadow-[0_10px_30px_rgba(10,15,26,0.04)]" data-testid="footer-family-logo-inline">
              <img alt="Content Watch logo" className="h-full w-full object-contain object-right" src={siteData.family_logo} />
            </div>
          ) : null}
        </div>
      </div>

      <div className="space-y-4">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500" data-testid="footer-navigation-heading">Navigation</p>
        <div className="grid grid-cols-2 gap-x-5 gap-y-4" data-testid="footer-main-nav-links">
          {MAIN_NAV_ITEMS.map((item) => (
            <Link key={item.to} className="text-sm font-semibold uppercase tracking-[0.14em] text-slate-700 transition-colors hover:text-[#1338BE]" data-testid={`footer-nav-link-${item.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} to={item.to}>
              {item.label}
            </Link>
          ))}
        </div>
      </div>

      <div className="space-y-4">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500" data-testid="footer-location-hubs-heading">Authority hubs</p>
        <div className="flex flex-col gap-4" data-testid="footer-location-hubs-row">
          {LOCATION_HUB_LIST.map((hub) => (
            <Link key={hub.route} className="text-sm font-semibold uppercase tracking-[0.14em] text-slate-700 transition-colors hover:text-[#D21404]" data-testid={`footer-location-hub-link-${hub.key}`} to={hub.route}>
              {hub.title}
            </Link>
          ))}
        </div>
        <p className="pt-3 text-xs uppercase tracking-[0.18em] text-slate-500" data-testid="footer-copyright">© Content Watch HQ</p>
      </div>
    </div>
  </footer>
);